export { default as HeroTextColumn } from './HeroTextColumn';
